import { image } from "../../resource";
import color from "../../resource/color";

export type CompanyCode = "ICPF" | "ICPI" | "ICPL";

export interface TierDefinition {
  key: string;
  label: string;
  subLabel: string;
  color: string;
  img?: string;
  /** Default tier background, used when a program is created from scratch. */
  bg?: string;
}

export interface ShopTierCompanyConfig {
  company: CompanyCode;
  companyLabel: string;
  volumeUnit: string;
  percentLabel: string;
  tiers: TierDefinition[];
}

const DEFAULT_COMPANY: CompanyCode = "ICPF";

export const SHOP_TIER_CONFIG: Record<CompanyCode, ShopTierCompanyConfig> = {
  ICPF: {
    company: "ICPF",
    companyLabel: "ICP Fertilizer",
    volumeUnit: "ตัน ",
    percentLabel: "Top Up",
    tiers: [
      { key: "Follow", label: "Follow", subLabel: "0-999 ตัน", color: "#98C8FF", img: image.followFer, bg: image.followBg },
      { key: "Focus", label: "Focus", subLabel: "1,000-3,499 ตัน", color: "#23824A", img: image.focus, bg: image.focusBg },
      { key: "First", label: "First", subLabel: "3,500-5,999 ตัน ", color: "#128CFD", img: image.first, bg: image.firstBg },
      { key: "First+", label: "First+", subLabel: "6,000-9,999 ตัน ", color: "#9D5CF6", img: image.firstPlus, bg: image.firstPlusBg },
      { key: "Finale", label: "Finale", subLabel: "ตั้งแต่ 10,000 ตัน ", color: "#E8B236", img: image.finale, bg: image.finaleBg },
    ],
  },
  ICPI: {
    company: "ICPI",
    companyLabel: "ICP International",
    volumeUnit: "ตัน ",
    percentLabel: "Top Up",
    tiers: [
      { key: "Follow", label: "Follow", subLabel: "0-999 ตัน ", color: "#98BEFF", img: image.followInter, bg: image.followBg },
      { key: "Star", label: "Star", subLabel: "1,000-1,499 ตัน ", color: "#00CBD9", img: image.star, bg: image.starBg },
      { key: "Strategic", label: "Strategic", subLabel: "1,500-2,999 ตัน ", color: "#D5171F", img: image.strategic, bg: image.strategicBg },
      { key: "Wisdom", label: "Wisdom", subLabel: "3,000-4,999 ตัน ", color: "#672592", img: image.wisdom, bg: image.wisdomBg },
      { key: "Wisdom Plus", label: "Wisdom Plus", subLabel: "5,000 ตัน  ขึ้นไป", color: "#F7B93B", img: image.wisdomPlus, bg: image.wisdomPlusBg },
    ],
  },
  ICPL: {
    company: "ICPL",
    companyLabel: "ICP Ladda",
    volumeUnit: "ล้านบาท",
    percentLabel: "Top Up",
    tiers: [
      { key: "Basic", label: "Basic", subLabel: "0-5 ล้านบาท", color: "#99C8FF", img: image.basic, bg: image.basicBg },
      { key: "Potential Star", label: "Potential Star", subLabel: "5-9 ล้านบาท", color: "#7AE8CE", img: image.potentialStar, bg: image.potentialStarBg },
      { key: "Power Focus", label: "Power Focus", subLabel: "10-19 ล้านบาท", color: "#F67874", img: image.powerFocus, bg: image.powerFocusBg },
      { key: "Prestige", label: "Prestige", subLabel: "20-29 ล้านบาท", color: "#F5C363", img: image.prestige, bg: image.prestigeBg },
      { key: "Prestige Plus", label: "Prestige Plus", subLabel: "30-49 ล้านบาท", color: "#F8DF8D", img: image.prestigePlus, bg: image.prestigePlusBg },
      { key: "Partner", label: "Partner", subLabel: "50 ล้านบาทขึ้นไป", color: "#94bbf6", img: image.partner, bg: image.partnerBg },
    ],
  },
};

export function resolveShopTierConfig(company?: string | null): ShopTierCompanyConfig {
  if (company === "ICPF" || company === "ICPI" || company === "ICPL") {
    return SHOP_TIER_CONFIG[company];
  }
  return SHOP_TIER_CONFIG[DEFAULT_COMPANY];
}
